import './utils/counter';
import './utils/stripeModal';

jQuery(document).ready(function($) {
  console.log('allora');
  // Hamburger menu & Menu mobile
  $(".navbar-toggler").on("click", function () {
    $(".wrapper-menu-mobile").toggleClass("show");
    $(".navbar-toggler").toggleClass("is-toggled");
  });

  // Dropdown menu
  $(".menu-item--expanded").click(function (e) {
    // Don't close if clicking inside the dropdown menu
    if ($(e.target).closest('.dropdown-menu').length) {
      return;
    }
    
    $(".menu-item--expanded")
      .not(this)
      .children('.sub-menu')
      .removeClass("submenu-active");
    $(this).children('.sub-menu').toggleClass("submenu-active");

    $(this).toggleClass('is-active');
  });

  // Close dropdown when clicking outside
  $(document).on("click", function (e) {
    if ($(e.target).closest(".menu-item--expanded").length === 0) {
      $(".menu-item--expanded > .sub-menu").removeClass("submenu-active");
      if ($(".menu-item--expanded").hasClass('is-active')) {
        $(".menu-item--expanded").removeClass('is-active');
      }
    }
  });

  // Prevent dropdown from closing when clicking inside
  $('.dropdown-menu').on('click', function(e) {
    e.stopPropagation();
  });

  // Accordion
  $(".accordion__wrapper__title").on("click", function () {
    $(this).children(".accordion__icon").toggleClass("open");
  });

  const accordionBtns = document.querySelectorAll(".accordion__wrapper__title");
  accordionBtns.forEach((accordion) => {
    accordion.onclick = function () {
      this.classList.toggle("is-open");
      let content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    };
  });

  // Apri l'accordion TOC di default e correggi altezza
  const tocAccordion = document.querySelector('.toc .accordion__wrapper__title');
  if (tocAccordion) {
    tocAccordion.classList.add('is-open');
    const tocIcon = tocAccordion.querySelector('.accordion__icon');
    if (tocIcon) {
      tocIcon.classList.add('open');
    }
    let content = tocAccordion.nextElementSibling;
    if (content) {
      // Correggi altezza dopo che la TOC è stata popolata
      const adjustHeight = () => {
        content.style.maxHeight = content.scrollHeight + "px";
      };
      // Esegui l'aggiustamento dopo la generazione dinamica della TOC
      setTimeout(adjustHeight, 100);
    }
  }

  // Generazione dinamica della TOC
  const tocList = document.querySelector('.toc.auto .field--name-field-toc-text ul');
  const articleHeadings = document.querySelectorAll('article h2:not(.hero__page__wrapper h2)');
  if (tocList && articleHeadings.length > 0) {
    articleHeadings.forEach((heading, index) => {
      // Genera un ID unico per ogni h2
      const textContent = heading.textContent.trim();
      const id = `${index}-${textContent.replace(/\s+/g, '-').toLowerCase()}`;
      heading.setAttribute('id', id);

      // Crea un elemento <li> con un link all'h2
      const listItem = document.createElement('li');
      const anchor = document.createElement('a');
      anchor.href = `#${id}`;
      anchor.textContent = textContent;

      // Aggiungi il link all'elemento <li> e aggiungilo alla TOC
      listItem.appendChild(anchor);
      tocList.appendChild(listItem);
    });
  }

  // Swiper
  var cs2Swiper = new Swiper(".swiper-container", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 30,
    scrollbar: {
      el: ".swiper-scrollbar",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  // Marquee3k Initialization
  if (typeof Marquee3k !== "undefined") {
    Marquee3k.init();
    const marquee = $(".marquee3k");
    marquee.on("mouseover", Marquee3k.pauseAll);
    marquee.on("mouseout", Marquee3k.playAll);
  } else {
    console.error("Marquee3k is not loaded");
  }

  // init aos
  AOS.init();

  // Smooth scroll per anchor link interni
  $('a[href^="#"]').on('click', function(e) {
    const href = $(this).attr('href');
    if (href.length > 1 && href.startsWith('#')) {
      const target = document.getElementById(href.substring(1));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth' });
      }
    }
  });

  // Troncamento testo e pulsante + leggi tutto (mantieni HTML)
  function truncateHtml(html, maxLength) {
    var div = document.createElement('div');
    div.innerHTML = html;
    var total = 0;
    var done = false;
    function walk(node) {
      if (done) return '';
      if (node.nodeType === 3) { // text node
        if (total + node.nodeValue.length > maxLength) {
          var remain = maxLength - total;
          done = true;
          return node.nodeValue.slice(0, remain) + '...';
        } else {
          total += node.nodeValue.length;
          return node.nodeValue;
        }
      } else if (node.nodeType === 1) { // element node
        var html = '<' + node.nodeName.toLowerCase();
        for (var i = 0; i < node.attributes.length; i++) {
          html += ' ' + node.attributes[i].name + '="' + node.attributes[i].value + '"';
        }
        html += '>';
        for (var j = 0; j < node.childNodes.length; j++) {
          html += walk(node.childNodes[j]);
          if (done) break;
        }
        html += '</' + node.nodeName.toLowerCase() + '>';
        return html;
      }
      return '';
    }
    return walk(div);
  }

  const maxChars = 500; // puoi cambiare il limite qui
  const maxCharsWebForm = 4500; // puoi cambiare il limite qui
  // text media
  $('.column-text-wrap__text').each(function() {
    const fullHtml = $(this).html().trim();
    // Calcola il testo visibile senza tag
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fullHtml;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    if (plainText.length > maxChars) {
      const shortHtml = truncateHtml(fullHtml, maxChars);
      $(this).data('full-html', fullHtml);
      $(this).html('<span class="short-text">' + shortHtml + '</span>' +
        '<span class="full-text" style="display:none;">' + fullHtml + '</span>' +
        '<button class="btn-read-more" type="button">Leggi tutto</button>');
    }
  });
  // order info user
  $('.dn-section__text ul').each(function() {
    const fullHtml = $(this).html().trim();
    // Calcola il testo visibile senza tag
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = fullHtml;
    const plainText = tempDiv.textContent || tempDiv.innerText || '';
    if (plainText.length > maxCharsWebForm) {
      const shortHtml = truncateHtml(fullHtml, maxCharsWebForm);
      $(this).data('full-html', fullHtml);
      $(this).html('<span class="short-text">' + shortHtml + '</span>' +
        '<span class="full-text" style="display:none;">' + fullHtml + '</span>' +
        '<button class="btn-read-more-order" type="button">Leggi tutto</button>');
    }
  });

  $(document).on('click', '.btn-read-more', function() {
    const parent = $(this).closest('.column-text-wrap__text');
    const shortText = parent.find('.short-text');
    const fullText = parent.find('.full-text');

    if ($(this).text() === 'Leggi tutto') {
      // Espandi: mostra testo completo
      shortText.hide();
      fullText.show();
      $(this).text('Leggi meno').addClass('expanded');
    } else {
      // Comprimi: mostra testo troncato
      fullText.hide();
      shortText.show();
      $(this).text('Leggi tutto').removeClass('expanded');
    }
  });
  
  $(document).on('click', '.btn-read-more-order', function() {
    const parent = $(this).closest('.dn-section__text ul');
    const shortText = parent.find('.short-text');
    const fullText = parent.find('.full-text');
    
    if ($(this).text() === 'Leggi tutto') {
      // Espandi: mostra testo completo
      shortText.hide();
      fullText.show();
      $(this).text('Leggi meno').addClass('expanded');
    } else {
      // Comprimi: mostra testo troncato
      fullText.hide();
      shortText.show();
      $(this).text('Leggi tutto').removeClass('expanded');
    }
  });

  // Registrazione: auto-check delle checkbox consensi quando si clicca la prima
  if (window.location.pathname.includes('user/')) {
    // pagina user register
    $('[data-drupal-selector="edit-field-user-consent-privacy-info-value"]').on('change', function() {
      if ($(this).is(':checked')) {
        // Checka automaticamente tutte le altre checkbox dei consensi
        $('[data-drupal-selector="edit-field-user-consent-owner-service-value"]').prop('checked', true);
        $('[data-drupal-selector="edit-field-user-consent-requested-srv-value"]').prop('checked', true);
        $('[data-drupal-selector="edit-field-user-consent-newsletter-value"]').prop('checked', true);
        $('[data-drupal-selector="edit-field-user-consent-third-party-value"]').prop('checked', true);
      }
    });

    // pagina user edit
    $('[data-drupal-selector="edit-field-user-consent-privacy-info"]').on(
      "change",
      function () {
        if ($(this).is(":checked")) {
          // Checka automaticamente tutte le altre checkbox dei consensi
          $(
            '[data-drupal-selector="edit-field-user-consent-owner-service"]',
          ).prop("checked", true);
          $(
            '[data-drupal-selector="edit-field-user-consent-requested-srv"]',
          ).prop("checked", true);
          $(
            '[data-drupal-selector="edit-field-user-consent-newsletter"]',
          ).prop("checked", true);
          $(
            '[data-drupal-selector="edit-field-user-consent-third-party"]',
          ).prop("checked", true);
        }
      },
    );
  }
});
